import { getActiveChatJid, store } from '@/app/store';
import { getUserIdFromJid, logger } from '@/shared/utils';
import { cancelDownload, downloadMediaAndTriggerSave, executeDownload } from './downloadQueueManager';
import { cancelUpload, queueFile, queueMessage, queueMessages, resumeUpload } from './messageQueue';

export async function handleMediaAction(messageObject, actionType, fileSave = false) {
   const { msgId, msgType } = messageObject;
   const chatId = getUserIdFromJid(getActiveChatJid(store.getState()));

   const handlers = {
      download: () => executeDownload(msgId, chatId, fileSave),
      save: () => downloadMediaAndTriggerSave(chatId, msgId),
      cancelUpload: () => cancelUpload(msgId, chatId),
      resumeUpload: () => resumeUpload(messageObject, chatId, msgType),
      cancelDownload: () => cancelDownload(msgId, chatId),
   };

   const handler = handlers[actionType];
   if (handler) return await handler();

   logger.warn(`[MediaAction] Unknown action: ${actionType}`);
}

export {
   downloadMediaAndTriggerSave,
   queueFile as enqueueFile,
   queueMessage as enqueueMessage,
   queueMessages as addToMessageQueue,
};
